<div class="card-title-block card-title-block-adjusted">
	<div class="card-title-label" translate>{{data.question}}</div>
</div>

<div class="copo-offer-buttons-group">
	<button *ngIf="data.titleButtonCancel" type="button" mat-raised-button class="primary-action-white copo-offer-margin-5" (click)="evtCancel()" tabindex="-1">
		<span translate>eoffer.cancel</span>
	</button>
	<button type="button" mat-raised-button color="primary" class="primary-action-white copo-offer-margin-5" (click)="evtContinue()" tabindex="-1" copoFocusMe>
		<span translate>{{data.titleButtonContinue}}</span>
	</button>
</div>
